import { useCallback } from "react";
import { useAuth } from "@/context/AuthContext";
import { useModulePermissions } from "@/context/ModulePermissionsContext";
import { resolveAndOpenDefaultLandingWindow } from "./osDefaultLanding";
import { useOsActionsOptional, useOsWindowListOptional } from "./OsContext";

/** Opens the permission-based default aniOS app (advisor-dashboard, home, dashboard, …). */
export function useOsDefaultLandingOpener() {
  const { user } = useAuth();
  const { permissions, hasPermission, isLoading: isPermissionsLoading } =
    useModulePermissions();
  const osActions = useOsActionsOptional();
  const osWindows = useOsWindowListOptional();

  return useCallback(() => {
    if (
      isPermissionsLoading ||
      !permissions ||
      !osActions?.openWindow ||
      !osActions.focusWindow ||
      !osWindows?.getWindowsSnapshot
    ) {
      return;
    }

    resolveAndOpenDefaultLandingWindow({
      companyId: user?.company_id,
      initialRoute: permissions.initial_route,
      hasPermission,
      windows: osWindows.getWindowsSnapshot(),
      openWindow: osActions.openWindow,
      focusWindow: osActions.focusWindow,
    });
  }, [
    isPermissionsLoading,
    permissions,
    hasPermission,
    user?.company_id,
    osActions,
    osWindows,
  ]);
}
